__turbopack_context__.v({
  "fallback": "index-module__0dTLuG__fallback",
});
